/**
 * Distinguish network/unreachable errors from HTTP auth failures.
 */

export function isNetworkError(error) {
  if (!error) return false;
  if (!error.response) return true;
  const code = error.code;
  if (code === 'ERR_NETWORK' || code === 'ECONNABORTED') return true;
  const msg = String(error.message || '').toLowerCase();
  return msg.includes('network error') || msg.includes('failed to fetch');
}

export function isAuthError(error) {
  return error?.response?.status === 401;
}
